//

import $ from 'jquery';
import config from './../../../../config';

export function get_expense_reports(  start_date, end_date, user ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'hr-reports/',
			data: {
				method	: 'GET_EXPENSE_REPORTS',
				start_date: start_date, 
				end_date: end_date,
				user: user,
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "GET_EXPENSE_REPORTS",
				hr_meetings	: response
			})
		})

	}
}

export function get_initial_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'hr-reports/',
			data: {
				method	: 'GET_INITIAL_USERS',
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "GET_INITIAL_USERS",
				hr_meetings	: response
			})
		})

	}
}



// WEBPACK FOOTER //
// ./src/pages/hr-reports/expense/actions/expense.action.js